import { connect } from "react-redux";
// Component
import Additions from "components/CreateSurvey/Additions";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { showSnackbar } from "redux/modules/snackbar";
import {
  setErrors,
  initAdditions,
  updateAdditions,
  setAdditionsInfo,
  setAdditionsLocale,
  setAdditionsEdit,
  setAdditionsSelectedId,
  updateAdditionsItems,
  changeAdditionsItem,
  addAdditionsNewItem,
  removeAdditionsItem,
  addAdditionsNewAnswer,
  removeAdditionsAnswer,
  changeAdditionsAnswer,
  openPreviewModal,
  setAdditionsPtReverse,
  discardAdditions
} from "redux/modules/createSurvey";
// Utils
import history from "utils/history";
import { convertLocaleKeyToName } from "utils/formatter";
import api from "api";
import { validate as baseInfoValidate } from "../BaseInfo";
import { validate as selectAttrValidate } from "../SelectAttr";
import { validate as baseWordValidate } from "../BaseWord";

export const validate = (baseInfo, additions) => {
  const errors = [];
  baseInfo.useLocales.forEach(locale => {
    if (!additions.items[locale]) return;
    additions.items[locale].forEach(item => {
      if (item.content === "") {
        errors.push(
          `${convertLocaleKeyToName(locale)}: Q${
            item.id
          }の設問文を入力してください。`
        );
      }
      if (item.choices.length < 2) {
        errors.push(
          `${convertLocaleKeyToName(locale)}: Q${
            item.id
          }の回答（選択肢）２つ以上設定してください。`
        );
      }
      item.choices.forEach((choice, index) => {
        if (choice.name === "") {
          errors.push(
            `${convertLocaleKeyToName(locale)}: Q${
              item.id
            }の回答（選択肢）${index + 1}. を入力してください。`
          );
        }
      });
    });
  });
  return errors;
};

const mapStateToProps = state => ({
  survey: state.createSurvey.survey,
  additions: state.createSurvey.additions,
  locales: state.createSurvey.locales,
  baseInfo: state.createSurvey.baseInfo,
  selectAttr: state.createSurvey.selectAttr,
  baseWord: state.createSurvey.baseWord,
  errors: state.createSurvey.errors,
  alertDays: state.createSurvey.alertDays,
  isChecked: state.createSurvey.isChecked,
  isMailSendToEmployee: state.createSurvey.isMailSendToEmployee,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  init: () => {
    dispatch(initAdditions());
  },
  fetchSurveyDetail: () => {
    if (ownProps.match.path.indexOf("create_survey") > -1) {
      return;
    }
    const { id } = ownProps.match.params;
    api
      .get(`survey_detail/${id}/edit_additions`)
      .then(res => dispatch(setAdditionsInfo(res)))
      .catch(error => dispatch(openErrorDialog(error)));
  },
  handlePrev: () => {
    dispatch(setErrors([]));
    ownProps.history.goBack();
  },
  handleRegist: props => {
    const { survey, baseInfo, selectAttr, baseWord, additions, alertDays, isChecked, isMailSendToEmployee } = props;
    let errors = baseInfoValidate({ survey, baseInfo });
    errors = errors.concat(selectAttrValidate(baseInfo, selectAttr));
    errors = errors.concat(baseWordValidate(baseInfo, baseWord));
    if (additions.isEdit) {
      errors = errors.concat(validate(baseInfo, additions));
    }
    dispatch(setErrors(errors));

    if (errors.length > 0) {
      window.scroll(0, 0);
      return;
    }

    const safeAlertDays = alertDays !== undefined && alertDays !== null ? alertDays : "";
    const safeIsChecked = typeof isChecked === "boolean" ? isChecked : false;
    const safeIsMailSendToEmployee = typeof isMailSendToEmployee === "boolean" ? isMailSendToEmployee : false;

    const params = {
      baseInfo,
      selectAttr,
      baseWord,
      additions,
      alertDays: safeAlertDays,
      isChecked: safeIsChecked,
      isMailSendToEmployee: safeIsMailSendToEmployee
    };
    const dialogData = {
      title: "確認",
      contentText: "入力した内容でアンケートを作成します。よろしいですか？",
      btnLabel: "作成",
      handleClick: () => {
        const { id } = ownProps.match.params;
        if (additions.isEdit) {
          additions.isEdit =
            params.additions.items[baseInfo.useLocales[0]].length > 0;
        }
        api
          .post(`create_survey/${id}`, params)
          .then(res => {
            dispatch(closeConfirmDialog());

            if (res.errors) {
              dispatch(openErrorDialog(res.errors));
            } else {
              dispatch(showSnackbar("新規アンケートを作成しました。"));
              ownProps.history.push(`/admin/survey_detail/${res.survey.id}`);
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };
    dispatch(openConfirmDialog(dialogData));
  },
  handleUpdate: props => {
    const { baseInfo, additions, survey } = props;
    const errors = validate(baseInfo, additions);
    dispatch(setErrors(errors));

    if (errors.length > 0) {
      dispatch(setErrors(errors));
      window.scroll(0, 0);
      return;
    }

    const params = {
      survey: survey.toObject(),
      baseInfo,
      additions,
      check_flg: 0
    };
    const dialogData = {
      title: "確認",
      contentText: "使用する追加設問を変更します。よろしいですか？",
      btnLabel: "更新",
      handleClick: () => {
        const { id } = ownProps.match.params;
        api
          .post(`update_additions/${id}`, params)
          .then(res => {
            dispatch(closeConfirmDialog());
            dispatch(updateAdditions());

            if (res.errors) {
              dispatch(openErrorDialog(res.errors));
            } else {
              dispatch(showSnackbar("使用する追加設問を変更しました。"));
              ownProps.history.goBack();
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };
    dispatch(openConfirmDialog(dialogData));
  },
  changeLocale: (event, localeNo) => {
    dispatch(setAdditionsLocale(localeNo));
  },
  checked: event => {
    dispatch(setAdditionsEdit(event.target.checked));
  },
  selectItem: id => {
    dispatch(setAdditionsSelectedId(id));
  },
  changeItemOrder: (index, atIndex) => {
    dispatch(updateAdditionsItems(index, atIndex));
  },
  changeItem: (key, value) => {
    dispatch(changeAdditionsItem(key, value));
  },
  addNewItem: id => {
    dispatch(addAdditionsNewItem(id));
  },
  removeItem: id => {
    dispatch(removeAdditionsItem(id));
  },
  addNewAnswer: () => {
    dispatch(addAdditionsNewAnswer());
  },
  removeAnswer: index => {
    dispatch(removeAdditionsAnswer(index));
  },
  changeAnswer: (index, name) => {
    dispatch(changeAdditionsAnswer(index, name));
  },
  setPtReverse: () => {
    dispatch(setAdditionsPtReverse());
  },
  openPreviewModal: (localeNo, selectedItemId, items, choices) => {
    dispatch(openPreviewModal(localeNo, selectedItemId, items, true, choices));
  },
  discard: baseInfo => {
    const dialogData = {
      title: "確認",
      contentText:
        "追加設問の設定を全て編集前の状態に戻します。よろしいですか？",
      btnLabel: "実行",
      handleClick: () => {
        if (baseInfo.baseSurveyId) {
          api
            .get(`discard_additions/${baseInfo.baseSurveyId}`, {
              limit: baseInfo.additionLimit
            })
            .then(res => {
              if (res.errors) {
                dispatch(openErrorDialog(res.errors));
              } else {
                dispatch(discardAdditions(res));
                dispatch(closeConfirmDialog());
              }
            })
            .catch(error => dispatch(openErrorDialog(error)));
        } else {
          dispatch(discardAdditions());
          dispatch(closeConfirmDialog());
        }
      }
    };
    dispatch(openConfirmDialog(dialogData));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Additions);



// WEBPACK FOOTER //
// ./src/containers/CreateSurvey/Additions/index.js